module.exports = __webpack_public_path__ + "static/img/Spinner_1.6622950.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/Spinner_1.gif
// module id = Uore
// module chunks = 1